import React from "react"
import styled from "styled-components"
import Header from "~/components/organisms/Header"
import Footer from "~/components/organisms/Footer"
import HeaderTitle from "~/components/atoms/HeaderTitle"
import { useRouter } from "next/router"

const App = styled.div`
  position: relative;
`

const MainContainer = styled.div`
  min-height: 100vh;

  ${(props) => (props.theme === "WHITE" ? `background-color: #fff;` : `background-color: #f6f9fc;`)}
`

export default function DefaultLayout({ children, theme }) {
  const { pathname } = useRouter()
  const isCallVideoPage = pathname.includes("/video")
  return (
    <>
      <App className="app">
        {!isCallVideoPage && (
          <>
            <Header />
            <HeaderTitle />
          </>
        )}
        <MainContainer theme={theme}>{children}</MainContainer>
        {!isCallVideoPage && <Footer />}
      </App>
    </>
  )
}
